import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  FileSpreadsheet, 
  ArrowRight,
  Check,
  Sparkles,
  Phone,
  Mail,
  MapPin,
  User,
  DollarSign,
  List,
  Play,
  Pause,
  ChevronRight,
  Zap,
  Globe,
  SplitSquareHorizontal
} from 'lucide-react';

// Sample messy data (50 rows) based on the provided CSV
const SAMPLE_DATA = [
  { fullName: "Lily - Rose Depp", email: "LILYRO_4@OUTLOOK.COM", phone: "+01 (521) 819-6001", state: "GA", country: "Canada", industry: " Retail", revenue: "USD 407431601", lifecycle: "opportunity" },
  { fullName: "Millie - Bobby Brown", email: "MILLIEBOBBYBROWN.433@YAHOO.COM", phone: "+01 (711) 615-5940", state: "WI", country: "United States", industry: " Healthcare", revenue: "24651779", lifecycle: "sales qualified lead" },
  { fullName: "Selena Gomez", email: " selenagomez@example.com ", phone: "952.553.4192", state: "Michigan", country: "US", industry: "REAL ESTATE", revenue: "$0.432B", lifecycle: "sales qualified lead" },
  { fullName: "Lupita  Nyongo", email: " lupita_28@company.co ", phone: "+1-576-724-2388 ext 279", state: "NL", country: "Mexico", industry: "REAL ESTATE", revenue: '"462,351,106 USD"', lifecycle: "lead" },
  { fullName: "Sandra - Bullock", email: "sandrabullock.164@hotmail.com", phone: "869-784-8018 x283", state: "IA", country: "fr", industry: "Education ", revenue: "USD 409125341", lifecycle: " opportunity " },
  { fullName: "Tom  Hanks", email: "TOMHANKS@GMAIL.COM", phone: "(555) 123-4567", state: "CA", country: "usa", industry: "entertainment", revenue: "$1.2B", lifecycle: "customer" },
  { fullName: "Jennifer - Lawrence", email: " jlaw_movies@yahoo.com", phone: "555.987.6543", state: "kentucky", country: "United States of America", industry: " Film ", revenue: "89000000", lifecycle: "LEAD" },
  { fullName: "Robert  Downey Jr", email: "rdj@stark.com  ", phone: "+1-800-IRONMAN", state: "NY", country: "US", industry: "TECH", revenue: "USD 500M", lifecycle: "customer" },
  { fullName: "Emma - Stone", email: "EMMASTONE123@HOTMAIL.COM", phone: "123 456 7890", state: "AZ", country: "america", industry: "Movies", revenue: "$75,000,000", lifecycle: " opportunity" },
  { fullName: "Chris  Hemsworth", email: "thor@avengers.net", phone: "+61 (2) 9876 5432", state: "NSW", country: "Australia", industry: " fitness ", revenue: "AUD 200000000", lifecycle: "sql" },
  { fullName: "Scarlett - Johansson", email: " scarjo@blackwidow.com ", phone: "1-555-WIDOW", state: "New York", country: "US", industry: "Acting", revenue: "$165M", lifecycle: "Customer" },
  { fullName: "Leonardo  DiCaprio", email: "LEO_DICAPRIO@ENV.ORG", phone: "310.555.1234", state: "california", country: "USA", industry: "ENVIRONMENT", revenue: "450000000 USD", lifecycle: "lead " },
  { fullName: "Natalie - Portman", email: "natalie.portman@harvard.edu", phone: "+972-54-123-4567", state: "MA", country: "Israel", industry: " Education", revenue: "$90,000,000", lifecycle: "mql" },
  { fullName: "Brad  Pitt", email: "BRADPITT_ACTOR@AOL.COM", phone: "(818) 555-0199", state: "MO", country: "united states", industry: "film production", revenue: "$0.4B", lifecycle: "CUSTOMER" },
  { fullName: "Angelina - Jolie", email: " angie@unhcr.org ", phone: "202.555.0123", state: "DC", country: "US", industry: " Nonprofit ", revenue: "USD 120000000", lifecycle: "advocate" },
  { fullName: "Denzel  Washington", email: "denzel.w@gmail.com", phone: "1 (914) 555 7890", state: "NY", country: "America", industry: "ACTING", revenue: "280M", lifecycle: " lead" },
  { fullName: "Meryl - Streep", email: "MERYLSTREEP@OSCAR.COM", phone: "+1-203-555-4567", state: "Connecticut", country: "US", industry: "Theatre", revenue: "$160,000,000", lifecycle: "customer" },
  { fullName: "Morgan  Freeman", email: "morgan_freeman@voice.io", phone: "(601) 555.8901", state: "mississippi", country: "USA", industry: " Narration ", revenue: "USD 250M", lifecycle: "Customer" },
  { fullName: "Julia - Roberts", email: " juliaroberts@prettywoman.com", phone: "404-555-2345", state: "GA", country: "united states of america", industry: "FILM", revenue: "0.25B", lifecycle: "sql " },
  { fullName: "Matt  Damon", email: "MATTDAMON@BOURNE.NET", phone: "+1 (617) 555-6789", state: "Massachusetts", country: "US", industry: "Action", revenue: "$170000000", lifecycle: "lead" },
  { fullName: "Cate - Blanchett", email: "cate.blanchett@theatre.au", phone: "+61 2 9555 0123", state: "NSW", country: "australia", industry: " Theatre ", revenue: "AUD 95000000", lifecycle: "MQL" },
  { fullName: "George  Clooney", email: " GCLOONEY@NESPRESSO.COM ", phone: "859.555.4321", state: "KY", country: "US", industry: "Coffee", revenue: "USD 500,000,000", lifecycle: " customer " },
  { fullName: "Anne - Hathaway", email: "anne_hathaway@broadway.com", phone: "1-212-555-8765", state: "new york", country: "USA", industry: "MUSICAL", revenue: "$80M", lifecycle: "opportunity" },
  { fullName: "Ryan  Gosling", email: "ryangosling@laland.com", phone: "(323) 555-0987", state: "CA", country: "canada", industry: " Acting", revenue: "CAD 70000000", lifecycle: "Lead" },
  { fullName: "Charlize - Theron", email: "CHARLIZE@ATOMIC.IO", phone: "+27 21 555 6543", state: "WC", country: "South Africa", industry: "Production", revenue: "$130,000,000", lifecycle: " sql" },
  { fullName: "Hugh  Jackman", email: " hughjackman@wolverine.com", phone: "+61-2-5555-7890", state: "NSW", country: "AUS", industry: "BROADWAY", revenue: "AUD 180M", lifecycle: "customer" },
  { fullName: "Nicole - Kidman", email: "nicolekidman@amc.com", phone: "615.555.2345", state: "Tennessee", country: "australia", industry: " Television ", revenue: "$250000000", lifecycle: "Customer " },
  { fullName: "Keanu  Reeves", email: "KEANU_REEVES@MATRIX.NET", phone: "+1 (310) 555-1111", state: "CA", country: "Canada", industry: "Action", revenue: "USD 380M", lifecycle: "advocate" },
  { fullName: "Amy - Adams", email: "amyadams@enchanted.com ", phone: "1-720-555-9876", state: "colorado", country: "US", industry: "DRAMA", revenue: "$60,000,000", lifecycle: " mql" },
  { fullName: "Will  Smith", email: " WILLSMITH@FRESHPRINCE.TV ", phone: "(215) 555-0000", state: "PA", country: "United States", industry: " Entertainment", revenue: "0.35B USD", lifecycle: "lead" },
  { fullName: "Margot - Robbie", email: "margot.robbie@barbie.com", phone: "+61 7 5555 1234", state: "QLD", country: "aus", industry: "Film", revenue: "AUD 26000000", lifecycle: "SQL" },
  { fullName: "Christian  Bale", email: "christianbale@batman.dc", phone: "44-20-5555-4567", state: "London", country: "UK", industry: " Superhero ", revenue: "GBP 120M", lifecycle: " customer" },
  { fullName: "Viola - Davis", email: "VIOLADAVIS@HTGAWM.COM", phone: "+1-803-555-8901", state: "South Carolina", country: "usa", industry: "TELEVISION", revenue: "$45,000,000", lifecycle: "Customer" },
  { fullName: "Jake  Gyllenhaal", email: " jake_gyllenhaal@indie.com ", phone: "1 (323) 555-2222", state: "california", country: "US", industry: "Drama", revenue: "USD 80M", lifecycle: "opportunity " },
  { fullName: "Rachel - McAdams", email: "rachelmcadams@notebook.ca", phone: "(519) 555-3333", state: "ON", country: "canada", industry: " Romance ", revenue: "CAD 40000000", lifecycle: "lead" },
  { fullName: "Michael  B Jordan", email: "MBJ@CREED.COM", phone: "+1-510-555-4444", state: "CA", country: "America", industry: "BOXING", revenue: "$25,000,000", lifecycle: " SQL" },
  { fullName: "Zendaya - Coleman", email: "zendaya@euphoria.hbo", phone: "1.510.555.5555", state: "california", country: "US", industry: " Fashion", revenue: "USD 20M", lifecycle: "MQL" },
  { fullName: "Timothee  Chalamet", email: " TIMOTHEE@DUNE.COM ", phone: "+1 (212) 555-6666", state: "NY", country: "france", industry: "Sci-Fi", revenue: "$15,000,000", lifecycle: " lead " },
  { fullName: "Florence - Pugh", email: "florencepugh@marvel.uk", phone: "44 20 5555 7777", state: "Oxfordshire", country: "UK", industry: "ACTION", revenue: "GBP 8M", lifecycle: "opportunity" },
  { fullName: "Oscar  Isaac", email: "oscarisaac@moonknight.disney", phone: "(305) 555-8888", state: "florida", country: "Guatemala", industry: " Disney ", revenue: "$12,000,000", lifecycle: "Customer" },
  { fullName: "Saoirse - Ronan", email: "SAOIRSE@BROOKLYN.IE", phone: "+353 1 555 9999", state: "Dublin", country: "ireland", industry: "Independent", revenue: "EUR 35M", lifecycle: " customer" },
  { fullName: "Daniel  Kaluuya", email: " danielkaluuya@getout.com ", phone: "44-20-5555-0001", state: "London", country: "UK", industry: "HORROR", revenue: "GBP 20,000,000", lifecycle: "sql" },
  { fullName: "Awkwafina - Lum", email: "awkwafina@shang.chi", phone: "+1 (718) 555-1112", state: "new york", country: "US", industry: " Comedy ", revenue: "$10M", lifecycle: "Lead " },
  { fullName: "John  Boyega", email: "JOHNBOYEGA@STARWARS.COM", phone: "44 20 5555 2223", state: "London", country: "uk", industry: "Sci-Fi", revenue: "GBP 17M", lifecycle: " MQL" },
  { fullName: "Lupita - Nyongo", email: "lupita@wakanda.forever", phone: "+254 20 555 3334", state: "Nairobi", country: "Kenya", industry: "MARVEL", revenue: "USD 15,000,000", lifecycle: "customer" },
  { fullName: "Dev  Patel", email: " devpatel@slumdog.in ", phone: "+44-20-5555-4445", state: "London", country: "India", industry: " Drama", revenue: "GBP 12M", lifecycle: " Opportunity" },
  { fullName: "Gemma - Chan", email: "GEMMACHAN@ETERNALS.COM", phone: "+44 20 5555 5556", state: "London", country: "UK", industry: "Fashion", revenue: "$8,000,000", lifecycle: "sql " },
  { fullName: "Rami  Malek", email: "ramimalek@mrrobot.io", phone: "1 (818) 555-6667", state: "california", country: "egypt", industry: " Tech ", revenue: "USD 20M", lifecycle: "CUSTOMER" },
  { fullName: "Tessa - Thompson", email: " tessathompson@valkyrie.com", phone: "(310) 555-7778", state: "CA", country: "US", industry: "SUPERHERO", revenue: "$9,000,000", lifecycle: "lead" },
  { fullName: "Simu  Liu", email: "SIMULIU@SHANGCHI.MARVEL", phone: "+1-416-555-8889", state: "Ontario", country: "canada", industry: "Action", revenue: "CAD 15,000,000", lifecycle: " Lead" },
];

// Cleaned versions (50 rows) - Note: first names have no hyphens
const CLEANED_DATA = [
  { firstName: "Lily Rose", lastName: "Depp", email: "lilyro_4@outlook.com", phone: "+1 (521) 819-6001", state: "GA", country: "Canada", industry: "Retail", revenue: "$407,431,601", lifecycle: "Opportunity" },
  { firstName: "Millie Bobby", lastName: "Brown", email: "milliebobbybrown.433@yahoo.com", phone: "+1 (711) 615-5940", state: "WI", country: "United States", industry: "Healthcare", revenue: "$24,651,779", lifecycle: "Sales Qualified Lead" },
  { firstName: "Selena", lastName: "Gomez", email: "selenagomez@example.com", phone: "+1 (952) 553-4192", state: "MI", country: "United States", industry: "Real Estate", revenue: "$432,000,000", lifecycle: "Sales Qualified Lead" },
  { firstName: "Lupita", lastName: "Nyong'o", email: "lupita_28@company.co", phone: "+1 (576) 724-2388", state: "NL", country: "Mexico", industry: "Real Estate", revenue: "$462,351,106", lifecycle: "Lead" },
  { firstName: "Sandra", lastName: "Bullock", email: "sandrabullock.164@hotmail.com", phone: "+1 (869) 784-8018", state: "IA", country: "France", industry: "Education", revenue: "$409,125,341", lifecycle: "Opportunity" },
  { firstName: "Tom", lastName: "Hanks", email: "tomhanks@gmail.com", phone: "+1 (555) 123-4567", state: "CA", country: "United States", industry: "Entertainment", revenue: "$1,200,000,000", lifecycle: "Customer" },
  { firstName: "Jennifer", lastName: "Lawrence", email: "jlaw_movies@yahoo.com", phone: "+1 (555) 987-6543", state: "KY", country: "United States", industry: "Film", revenue: "$89,000,000", lifecycle: "Lead" },
  { firstName: "Robert", lastName: "Downey Jr", email: "rdj@stark.com", phone: "+1 (800) 476-6626", state: "NY", country: "United States", industry: "Tech", revenue: "$500,000,000", lifecycle: "Customer" },
  { firstName: "Emma", lastName: "Stone", email: "emmastone123@hotmail.com", phone: "+1 (123) 456-7890", state: "AZ", country: "United States", industry: "Movies", revenue: "$75,000,000", lifecycle: "Opportunity" },
  { firstName: "Chris", lastName: "Hemsworth", email: "thor@avengers.net", phone: "+61 (2) 9876-5432", state: "NSW", country: "Australia", industry: "Fitness", revenue: "$200,000,000", lifecycle: "Sales Qualified Lead" },
  { firstName: "Scarlett", lastName: "Johansson", email: "scarjo@blackwidow.com", phone: "+1 (555) 943-6900", state: "NY", country: "United States", industry: "Acting", revenue: "$165,000,000", lifecycle: "Customer" },
  { firstName: "Leonardo", lastName: "DiCaprio", email: "leo_dicaprio@env.org", phone: "+1 (310) 555-1234", state: "CA", country: "United States", industry: "Environment", revenue: "$450,000,000", lifecycle: "Lead" },
  { firstName: "Natalie", lastName: "Portman", email: "natalie.portman@harvard.edu", phone: "+972 (54) 123-4567", state: "MA", country: "Israel", industry: "Education", revenue: "$90,000,000", lifecycle: "Marketing Qualified Lead" },
  { firstName: "Brad", lastName: "Pitt", email: "bradpitt_actor@aol.com", phone: "+1 (818) 555-0199", state: "MO", country: "United States", industry: "Film Production", revenue: "$400,000,000", lifecycle: "Customer" },
  { firstName: "Angelina", lastName: "Jolie", email: "angie@unhcr.org", phone: "+1 (202) 555-0123", state: "DC", country: "United States", industry: "Nonprofit", revenue: "$120,000,000", lifecycle: "Advocate" },
  { firstName: "Denzel", lastName: "Washington", email: "denzel.w@gmail.com", phone: "+1 (914) 555-7890", state: "NY", country: "United States", industry: "Acting", revenue: "$280,000,000", lifecycle: "Lead" },
  { firstName: "Meryl", lastName: "Streep", email: "merylstreep@oscar.com", phone: "+1 (203) 555-4567", state: "CT", country: "United States", industry: "Theatre", revenue: "$160,000,000", lifecycle: "Customer" },
  { firstName: "Morgan", lastName: "Freeman", email: "morgan_freeman@voice.io", phone: "+1 (601) 555-8901", state: "MS", country: "United States", industry: "Narration", revenue: "$250,000,000", lifecycle: "Customer" },
  { firstName: "Julia", lastName: "Roberts", email: "juliaroberts@prettywoman.com", phone: "+1 (404) 555-2345", state: "GA", country: "United States", industry: "Film", revenue: "$250,000,000", lifecycle: "Sales Qualified Lead" },
  { firstName: "Matt", lastName: "Damon", email: "mattdamon@bourne.net", phone: "+1 (617) 555-6789", state: "MA", country: "United States", industry: "Action", revenue: "$170,000,000", lifecycle: "Lead" },
  { firstName: "Cate", lastName: "Blanchett", email: "cate.blanchett@theatre.au", phone: "+61 (2) 9555-0123", state: "NSW", country: "Australia", industry: "Theatre", revenue: "$95,000,000", lifecycle: "Marketing Qualified Lead" },
  { firstName: "George", lastName: "Clooney", email: "gclooney@nespresso.com", phone: "+1 (859) 555-4321", state: "KY", country: "United States", industry: "Coffee", revenue: "$500,000,000", lifecycle: "Customer" },
  { firstName: "Anne", lastName: "Hathaway", email: "anne_hathaway@broadway.com", phone: "+1 (212) 555-8765", state: "NY", country: "United States", industry: "Musical", revenue: "$80,000,000", lifecycle: "Opportunity" },
  { firstName: "Ryan", lastName: "Gosling", email: "ryangosling@laland.com", phone: "+1 (323) 555-0987", state: "CA", country: "Canada", industry: "Acting", revenue: "$70,000,000", lifecycle: "Lead" },
  { firstName: "Charlize", lastName: "Theron", email: "charlize@atomic.io", phone: "+27 (21) 555-6543", state: "WC", country: "South Africa", industry: "Production", revenue: "$130,000,000", lifecycle: "Sales Qualified Lead" },
  { firstName: "Hugh", lastName: "Jackman", email: "hughjackman@wolverine.com", phone: "+61 (2) 5555-7890", state: "NSW", country: "Australia", industry: "Broadway", revenue: "$180,000,000", lifecycle: "Customer" },
  { firstName: "Nicole", lastName: "Kidman", email: "nicolekidman@amc.com", phone: "+1 (615) 555-2345", state: "TN", country: "Australia", industry: "Television", revenue: "$250,000,000", lifecycle: "Customer" },
  { firstName: "Keanu", lastName: "Reeves", email: "keanu_reeves@matrix.net", phone: "+1 (310) 555-1111", state: "CA", country: "Canada", industry: "Action", revenue: "$380,000,000", lifecycle: "Advocate" },
  { firstName: "Amy", lastName: "Adams", email: "amyadams@enchanted.com", phone: "+1 (720) 555-9876", state: "CO", country: "United States", industry: "Drama", revenue: "$60,000,000", lifecycle: "Marketing Qualified Lead" },
  { firstName: "Will", lastName: "Smith", email: "willsmith@freshprince.tv", phone: "+1 (215) 555-0000", state: "PA", country: "United States", industry: "Entertainment", revenue: "$350,000,000", lifecycle: "Lead" },
  { firstName: "Margot", lastName: "Robbie", email: "margot.robbie@barbie.com", phone: "+61 (7) 5555-1234", state: "QLD", country: "Australia", industry: "Film", revenue: "$26,000,000", lifecycle: "Sales Qualified Lead" },
  { firstName: "Christian", lastName: "Bale", email: "christianbale@batman.dc", phone: "+44 (20) 5555-4567", state: "London", country: "United Kingdom", industry: "Superhero", revenue: "$120,000,000", lifecycle: "Customer" },
  { firstName: "Viola", lastName: "Davis", email: "violadavis@htgawm.com", phone: "+1 (803) 555-8901", state: "SC", country: "United States", industry: "Television", revenue: "$45,000,000", lifecycle: "Customer" },
  { firstName: "Jake", lastName: "Gyllenhaal", email: "jake_gyllenhaal@indie.com", phone: "+1 (323) 555-2222", state: "CA", country: "United States", industry: "Drama", revenue: "$80,000,000", lifecycle: "Opportunity" },
  { firstName: "Rachel", lastName: "McAdams", email: "rachelmcadams@notebook.ca", phone: "+1 (519) 555-3333", state: "ON", country: "Canada", industry: "Romance", revenue: "$40,000,000", lifecycle: "Lead" },
  { firstName: "Michael B", lastName: "Jordan", email: "mbj@creed.com", phone: "+1 (510) 555-4444", state: "CA", country: "United States", industry: "Boxing", revenue: "$25,000,000", lifecycle: "Sales Qualified Lead" },
  { firstName: "Zendaya", lastName: "Coleman", email: "zendaya@euphoria.hbo", phone: "+1 (510) 555-5555", state: "CA", country: "United States", industry: "Fashion", revenue: "$20,000,000", lifecycle: "Marketing Qualified Lead" },
  { firstName: "Timothée", lastName: "Chalamet", email: "timothee@dune.com", phone: "+1 (212) 555-6666", state: "NY", country: "France", industry: "Sci-Fi", revenue: "$15,000,000", lifecycle: "Lead" },
  { firstName: "Florence", lastName: "Pugh", email: "florencepugh@marvel.uk", phone: "+44 (20) 5555-7777", state: "Oxfordshire", country: "United Kingdom", industry: "Action", revenue: "$8,000,000", lifecycle: "Opportunity" },
  { firstName: "Oscar", lastName: "Isaac", email: "oscarisaac@moonknight.disney", phone: "+1 (305) 555-8888", state: "FL", country: "Guatemala", industry: "Disney", revenue: "$12,000,000", lifecycle: "Customer" },
  { firstName: "Saoirse", lastName: "Ronan", email: "saoirse@brooklyn.ie", phone: "+353 (1) 555-9999", state: "Dublin", country: "Ireland", industry: "Independent", revenue: "$35,000,000", lifecycle: "Customer" },
  { firstName: "Daniel", lastName: "Kaluuya", email: "danielkaluuya@getout.com", phone: "+44 (20) 5555-0001", state: "London", country: "United Kingdom", industry: "Horror", revenue: "$20,000,000", lifecycle: "Sales Qualified Lead" },
  { firstName: "Awkwafina", lastName: "Lum", email: "awkwafina@shang.chi", phone: "+1 (718) 555-1112", state: "NY", country: "United States", industry: "Comedy", revenue: "$10,000,000", lifecycle: "Lead" },
  { firstName: "John", lastName: "Boyega", email: "johnboyega@starwars.com", phone: "+44 (20) 5555-2223", state: "London", country: "United Kingdom", industry: "Sci-Fi", revenue: "$17,000,000", lifecycle: "Marketing Qualified Lead" },
  { firstName: "Lupita", lastName: "Nyong'o", email: "lupita@wakanda.forever", phone: "+254 (20) 555-3334", state: "Nairobi", country: "Kenya", industry: "Marvel", revenue: "$15,000,000", lifecycle: "Customer" },
  { firstName: "Dev", lastName: "Patel", email: "devpatel@slumdog.in", phone: "+44 (20) 5555-4445", state: "London", country: "India", industry: "Drama", revenue: "$12,000,000", lifecycle: "Opportunity" },
  { firstName: "Gemma", lastName: "Chan", email: "gemmachan@eternals.com", phone: "+44 (20) 5555-5556", state: "London", country: "United Kingdom", industry: "Fashion", revenue: "$8,000,000", lifecycle: "Sales Qualified Lead" },
  { firstName: "Rami", lastName: "Malek", email: "ramimalek@mrrobot.io", phone: "+1 (818) 555-6667", state: "CA", country: "Egypt", industry: "Tech", revenue: "$20,000,000", lifecycle: "Customer" },
  { firstName: "Tessa", lastName: "Thompson", email: "tessathompson@valkyrie.com", phone: "+1 (310) 555-7778", state: "CA", country: "United States", industry: "Superhero", revenue: "$9,000,000", lifecycle: "Lead" },
  { firstName: "Simu", lastName: "Liu", email: "simuliu@shangchi.marvel", phone: "+1 (416) 555-8889", state: "ON", country: "Canada", industry: "Action", revenue: "$15,000,000", lifecycle: "Lead" },
];

const FEATURES = [
  {
    id: 'name-split',
    title: 'Full Name Split',
    description: 'Automatically splits full names into first and last name columns',
    icon: SplitSquareHorizontal,
    color: 'indigo',
    beforeCol: 'fullName',
    afterCols: ['firstName', 'lastName'],
  },
  {
    id: 'email-fix',
    title: 'Email Standardization',
    description: 'Fixes formatting, removes extra spaces, and validates email addresses',
    icon: Mail,
    color: 'blue',
    beforeCol: 'email',
    afterCols: ['email'],
  },
  {
    id: 'phone-format',
    title: 'Phone Number Formatting',
    description: 'Standardizes phone numbers to consistent format, removes extensions',
    icon: Phone,
    color: 'emerald',
    beforeCol: 'phone',
    afterCols: ['phone'],
  },
  {
    id: 'state-country',
    title: 'State & Country Standardization',
    description: 'Converts state abbreviations and country names to standard format',
    icon: MapPin,
    color: 'purple',
    beforeCol: 'country',
    afterCols: ['country'],
  },
  {
    id: 'revenue',
    title: 'Revenue Standardization',
    description: 'Normalizes currency formats, converts billions/millions to numbers',
    icon: DollarSign,
    color: 'amber',
    beforeCol: 'revenue',
    afterCols: ['revenue'],
  },
  {
    id: 'dropdown',
    title: 'Dropdown Standardization',
    description: 'Fixes inconsistent values, trims spaces, standardizes casing',
    icon: List,
    color: 'rose',
    beforeCol: 'lifecycle',
    afterCols: ['lifecycle'],
  },
];

const DemoPage = () => {
  const navigate = useNavigate();
  const [activeFeature, setActiveFeature] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [showCleaned, setShowCleaned] = useState(false);

  // Auto-rotate features
  useEffect(() => {
    if (!isPlaying) return;
    
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % FEATURES.length);
      setShowCleaned(false);
      setTimeout(() => setShowCleaned(true), 500);
    }, 4000);
    
    return () => clearInterval(interval);
  }, [isPlaying]);

  // Show cleaned data after a delay when feature changes
  useEffect(() => {
    setShowCleaned(false);
    const timer = setTimeout(() => setShowCleaned(true), 800);
    return () => clearTimeout(timer);
  }, [activeFeature]);

  const currentFeature = FEATURES[activeFeature];

  const getColorClasses = (color) => {
    const colors = {
      indigo: { bg: 'bg-indigo-100', text: 'text-indigo-600', border: 'border-indigo-500', bgSolid: 'bg-indigo-600' },
      blue: { bg: 'bg-blue-100', text: 'text-blue-600', border: 'border-blue-500', bgSolid: 'bg-blue-600' },
      emerald: { bg: 'bg-emerald-100', text: 'text-emerald-600', border: 'border-emerald-500', bgSolid: 'bg-emerald-600' },
      purple: { bg: 'bg-purple-100', text: 'text-purple-600', border: 'border-purple-500', bgSolid: 'bg-purple-600' },
      amber: { bg: 'bg-amber-100', text: 'text-amber-600', border: 'border-amber-500', bgSolid: 'bg-amber-600' },
      rose: { bg: 'bg-rose-100', text: 'text-rose-600', border: 'border-rose-500', bgSolid: 'bg-rose-600' },
    };
    return colors[color] || colors.indigo;
  };

  const colors = getColorClasses(currentFeature.color);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <header className="border-b border-slate-700/50 bg-slate-900/50 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 bg-indigo-600 rounded-xl flex items-center justify-center">
                <FileSpreadsheet className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold text-white">CRM Data Cleaner</span>
            </Link>
            <div className="flex items-center gap-4">
              <Link to="/login">
                <Button className="bg-indigo-600 hover:bg-indigo-700 text-white">
                  Start Cleaning Data
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-indigo-500/10 border border-indigo-500/20 rounded-full px-4 py-2 mb-6">
            <Sparkles className="w-4 h-4 text-indigo-400" />
            <span className="text-sm text-indigo-300">See the magic in action</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Watch Your Messy Data<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">
              Transform Instantly
            </span>
          </h1>
          
          <p className="text-xl text-slate-400 max-w-2xl mx-auto mb-8">
            No more hours of manual cleanup. See how CRM Data Cleaner fixes names, emails, phones, and more with one click.
          </p>
        </div>
      </section>

      {/* Interactive Demo */}
      <section className="pb-24 px-4">
        <div className="max-w-6xl mx-auto">
          {/* Feature Selector */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {FEATURES.map((feature, idx) => {
              const featureColors = getColorClasses(feature.color);
              const Icon = feature.icon;
              return (
                <button
                  key={feature.id}
                  onClick={() => {
                    setActiveFeature(idx);
                    setIsPlaying(false);
                  }}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all ${
                    activeFeature === idx 
                      ? `${featureColors.bgSolid} text-white shadow-lg shadow-${feature.color}-500/25`
                      : 'bg-slate-800 text-slate-400 hover:bg-slate-700 hover:text-white'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="text-sm font-medium">{feature.title}</span>
                </button>
              );
            })}
          </div>

          {/* Play/Pause Control */}
          <div className="flex justify-center mb-8">
            <button
              onClick={() => setIsPlaying(!isPlaying)}
              className="flex items-center gap-2 px-4 py-2 bg-slate-800 rounded-full text-slate-400 hover:text-white transition-colors"
            >
              {isPlaying ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
              <span className="text-sm">{isPlaying ? 'Pause Demo' : 'Auto-Play'}</span>
            </button>
          </div>

          {/* Demo Card */}
          <div className="bg-slate-800/50 backdrop-blur rounded-2xl border border-slate-700 overflow-hidden">
            {/* Feature Header */}
            <div className={`p-6 border-b border-slate-700 ${colors.bg}`}>
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 ${colors.bgSolid} rounded-xl flex items-center justify-center`}>
                  <currentFeature.icon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900">{currentFeature.title}</h3>
                  <p className="text-slate-600">{currentFeature.description}</p>
                </div>
              </div>
            </div>

            {/* Before/After Tables */}
            <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-slate-700">
              {/* Before */}
              <div className="p-6">
                <div className="flex items-center gap-2 mb-4">
                  <span className="w-3 h-3 bg-red-500 rounded-full"></span>
                  <span className="text-sm font-medium text-slate-400">Before (Messy Data)</span>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-slate-700">
                        <th className="text-left py-2 px-3 text-slate-400 font-medium">#</th>
                        <th className="text-left py-2 px-3 text-slate-400 font-medium capitalize">
                          {currentFeature.beforeCol.replace(/([A-Z])/g, ' $1').trim()}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {SAMPLE_DATA.slice(0, 25).map((row, idx) => (
                        <tr key={idx} className="border-b border-slate-700/50">
                          <td className="py-2 px-3 text-slate-500">{idx + 1}</td>
                          <td className="py-2 px-3 text-red-400 font-mono text-xs">
                            {row[currentFeature.beforeCol]}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* After */}
              <div className="p-6 bg-slate-900/30">
                <div className="flex items-center gap-2 mb-4">
                  <span className="w-3 h-3 bg-emerald-500 rounded-full"></span>
                  <span className="text-sm font-medium text-slate-400">After (Cleaned)</span>
                  {showCleaned && (
                    <span className="ml-auto text-xs text-emerald-400 flex items-center gap-1">
                      <Check className="w-3 h-3" /> Cleaned!
                    </span>
                  )}
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-slate-700">
                        <th className="text-left py-2 px-3 text-slate-400 font-medium">#</th>
                        {currentFeature.afterCols.map((col) => (
                          <th key={col} className="text-left py-2 px-3 text-slate-400 font-medium capitalize">
                            {col.replace(/([A-Z])/g, ' $1').trim()}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {CLEANED_DATA.slice(0, 25).map((row, idx) => (
                        <tr 
                          key={idx} 
                          className={`border-b border-slate-700/50 transition-all duration-500 ${
                            showCleaned ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'
                          }`}
                          style={{ transitionDelay: `${idx * 100}ms` }}
                        >
                          <td className="py-2 px-3 text-slate-500">{idx + 1}</td>
                          {currentFeature.afterCols.map((col) => (
                            <td key={col} className="py-2 px-3 text-emerald-400 font-mono text-xs">
                              {row[col]}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Stats Bar */}
            <div className="p-4 bg-slate-900/50 border-t border-slate-700 flex items-center justify-between">
              <div className="flex items-center gap-6">
                <div className="text-center">
                  <p className="text-2xl font-bold text-white">25</p>
                  <p className="text-xs text-slate-400">Rows Cleaned</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-emerald-400">100%</p>
                  <p className="text-xs text-slate-400">Accuracy</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-indigo-400">&lt;1s</p>
                  <p className="text-xs text-slate-400">Processing Time</p>
                </div>
              </div>
              
              <Link to="/login">
                <Button className="bg-indigo-600 hover:bg-indigo-700 text-white">
                  Try It Free
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* All Features Grid */}
      <section className="py-24 px-4 bg-slate-800/30">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-4">
            All Cleaning Features
          </h2>
          <p className="text-slate-400 text-center mb-12 max-w-2xl mx-auto">
            From simple formatting to complex transformations, we handle it all.
          </p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {FEATURES.map((feature) => {
              const featureColors = getColorClasses(feature.color);
              const Icon = feature.icon;
              return (
                <div 
                  key={feature.id}
                  className="bg-slate-800/50 rounded-xl p-6 border border-slate-700 hover:border-slate-600 transition-colors"
                >
                  <div className={`w-12 h-12 ${featureColors.bg} rounded-xl flex items-center justify-center mb-4`}>
                    <Icon className={`w-6 h-6 ${featureColors.text}`} />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2">{feature.title}</h3>
                  <p className="text-slate-400 text-sm">{feature.description}</p>
                </div>
              );
            })}
            
            {/* More Features */}
            <div className="bg-slate-800/50 rounded-xl p-6 border border-slate-700">
              <div className="w-12 h-12 bg-slate-700 rounded-xl flex items-center justify-center mb-4">
                <Globe className="w-6 h-6 text-slate-400" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Industry Detection</h3>
              <p className="text-slate-400 text-sm">Standardize industry names to consistent categories</p>
            </div>
            
            <div className="bg-slate-800/50 rounded-xl p-6 border border-slate-700">
              <div className="w-12 h-12 bg-slate-700 rounded-xl flex items-center justify-center mb-4">
                <User className="w-6 h-6 text-slate-400" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Gender Detection</h3>
              <p className="text-slate-400 text-sm">Detect gender from first names automatically</p>
            </div>
            
            <div className="bg-slate-800/50 rounded-xl p-6 border border-slate-700">
              <div className="w-12 h-12 bg-slate-700 rounded-xl flex items-center justify-center mb-4">
                <Zap className="w-6 h-6 text-slate-400" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">And 20+ More</h3>
              <p className="text-slate-400 text-sm">Date formatting, URL extraction, duplicates, and more</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Clean Your Data?
          </h2>
          <p className="text-xl text-slate-400 mb-8">
            Free to use. No credit card required.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/login">
              <Button size="lg" className="bg-indigo-600 hover:bg-indigo-700 text-white px-8">
                Start Cleaning Data
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-slate-800 py-8 px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <FileSpreadsheet className="w-5 h-5 text-indigo-500" />
            <span className="text-slate-400">© 2025 CRM Data Cleaner</span>
          </div>
          <div className="flex items-center gap-6">
            <Link to="/blog" className="text-slate-400 hover:text-white text-sm">Blog</Link>
            <Link to="/login" className="text-slate-400 hover:text-white text-sm">Login</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DemoPage;
